import { CacheStoreTag } from '@signage-player/cache';
import { CacheKey } from '@signage-player/data-store';
import { resolveInstanceId } from './instanceId';
export class DeviceService {
    constructor(config, logger, cacheManager) {
        this.config = config;
        this.logger = logger;
        this.cacheManager = cacheManager;
        this.deviceInfo = this.getDeviceInfo();
        this.deviceInfo
            .then(async (info) => {
            this.logger.setAdditionalContext({
                user: { id: info.hash, ip_address: await this.config.publicIp },
                os: { name: this.parseOsName(), version: this.parseOsVersion() },
            });
        })
            .catch(error => {
            this.logger.error('[DeviceService] Error setting additional context', { error: error });
        });
    }
    async getDeviceInfo() {
        const hash = resolveInstanceId();
        const cachedInfo = (await this.cacheManager.tag(CacheStoreTag.Persistent).get(CacheKey.DeviceInfo));
        if (cachedInfo?.hash === hash) {
            return cachedInfo;
        }
        this.logger.debug('[DeviceService] Building DeviceInfo for instance', { hash });
        const info = {
            manufacturer: this.parseManufacturer(),
            mac: null,
            hash,
            mbid: hash,
            cpuName: null,
            productName: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 120) : null,
            ram: this.parseRam(),
            arch: this.parseArch(),
        };
        await this.cacheManager.tag(CacheStoreTag.Persistent).set(CacheKey.DeviceInfo, info);
        return info;
    }
    parseManufacturer() {
        if (typeof navigator === 'undefined')
            return null;
        return `Browser (${navigator.userAgent.slice(0, 80)})`;
    }
    parseRam() {
        if (typeof navigator === 'undefined')
            return null;
        // navigator.deviceMemory is quantized to {0.25, 0.5, 1, 2, 4, 8} GB and
        // capped at 8 GB for fingerprinting protection — a 32 GB machine reports 4
        // or 8. Browsers cannot read true physical RAM; this is the closest we get.
        // Stored as KB to match device-node's convention (/proc/meminfo MemTotal).
        const dm = navigator.deviceMemory;
        return (typeof dm === 'number' && dm > 0) ? (dm * 1024 * 1024) : null;
    }
    parseArch() {
        if (typeof navigator === 'undefined')
            return null;
        const ua = navigator.userAgent;
        if (/x86_64|x64|Win64|WOW64/i.test(ua))
            return 'x64';
        if (/aarch64|arm64/i.test(ua))
            return 'arm64';
        if (/i[3-6]86/i.test(ua))
            return 'x86';
        return null;
    }
    parseOsName() {
        if (typeof navigator === 'undefined')
            return 'web';
        const ua = navigator.userAgent;
        if (/Windows/i.test(ua))
            return 'windows';
        if (/Mac OS X|Macintosh/i.test(ua))
            return 'macos';
        if (/Android/i.test(ua))
            return 'android';
        if (/Linux/i.test(ua))
            return 'linux';
        return 'web';
    }
    parseOsVersion() {
        if (typeof navigator === 'undefined')
            return '';
        const match = navigator.userAgent.match(/(Windows NT|Mac OS X|Android|Linux) ([0-9._]+)/);
        return match ? match[2].replace(/_/g, '.') : '';
    }
}
export default DeviceService;
//# sourceMappingURL=DeviceService.js.map